import Localization, { TrustedValue } from 'lib/localization';

export default {
    lxOverview() {
        return Localization.get('badoo_homepage@footer.overview');
    },
    lxBlog() {
        return Localization.get('badoo_homepage@footer.blog');
    },
    lxSafetyCentre() {
        return Localization.get('badoo_homepage@footer.safety_centre');
    },
    lxHelpCentre() {
        return Localization.get('badoo_homepage@footer.help_centre');
    },
    lxTerms() {
        return Localization.get('badoo_homepage@footer.terms');
    },
    lxPrivacy() {
        return Localization.get('badoo_homepage@footer.privacy');
    },
    lxCookies() {
        return Localization.get('badoo_homepage@footer.cookies');
    },
    lxCareers() {
        return Localization.get('badoo_homepage@footer.careers');
    },
    lxCities() {
        return Localization.get('badoo_homepage@footer.cities');
    },
    lxChat() {
        return Localization.get('badoo_homepage@footer.chat');
    },

    lxFollowUsTitle() {
        return Localization.get('badoo_homepage@footer.follow_us.title');
    },
    lxFacebook() {
        return Localization.get('badoo_homepage@footer.facebook');
    },
    lxLinkedIn() {
        return Localization.get('badoo_homepage@footer.linkedin');
    },
    lxTwitter() {
        return Localization.get('badoo_homepage@footer.twitter');
    },
    lxInstagram() {
        return Localization.get('badoo_homepage@footer.instagram');
    },
    lxDownloadTitle() {
        return Localization.get('badoo_homepage@footer.download.title');
    },
    lxLanguageTitle() {
        return Localization.get('badoo_homepage@footer.language.title');
    },
    lxDownloadCopyText() {
        return Localization.get('badoo_homepage@footer.download.copy.text', {
            __EOL__: TrustedValue.for('<br/>'),
        });
    },
    lxCopyright() {
        return Localization.get('badoo_homepage@footer.copyright');
    },
    lxSitemap() {
        return Localization.get('badoo_homepage@footer.sitemap');
    },
    lxSlaveryAct() {
        return Localization.get('badoo_homepage@footer.slavery_act');
    },
    lxPartOf() {
        return Localization.get('badoo_homepage@footer.part_of');
    },
};
